import { pick } from 'lodash';
import { useEffect } from 'react';
import { FieldErrors } from 'react-hook-form';

import type { IFocusRequest } from 'core/states/form';
import { focusFirstInvalidField } from 'core/utils/fieldFocus';

// For forms that render their fields without core/components/Form (wizard steps); Form does it
// itself. Runs once per `focusRequest` (the form context's), never on a plain errors change.
export const useFocusFirstInvalidField = (
  errors: FieldErrors,
  focusRequest: IFocusRequest | null
): void => {
  useEffect(() => {
    if (!focusRequest) {
      return;
    }

    focusFirstInvalidField(focusRequest.names ? pick(errors, focusRequest.names) : errors);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [focusRequest]);
};
